export default __webpack_public_path__ + "static/DSC_0388-c198a1c4f195134d4aa1d5a2fb36da43.jpg";